import styled from 'styled-components';
import { createGradientOrSolid } from '../../Helper/utils/utils';

export const StyledLocoBingo = styled.div`
    position: relative;
    font-family: var(--font-family), Arial;
    font-weight: bold;

    .container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        border-radius: 7px;
        background: var(--bundle-border-color);
        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.4);

        .ribbon {
            border: 1px solid #760701;
            width: auto;
            border-radius: 2px 14px 14px 2px;
            background: ${({ ribbonBackgroundColor }: any) =>
                createGradientOrSolid(ribbonBackgroundColor)};
            position: absolute;
            color: ${({ ribbonTextColor }: any) => ribbonTextColor.colorOne};
            bottom: 34px;
            left: -4px;
            min-height: 24px;

            &__text {
                padding: 4px 6px;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                text-transform: capitalize;
                line-height: normal;
                text-shadow: -1px -1px 0 #c01303, 1px -1px 0 #c01303,
                    -1px 1px 0 #c01303, 1px 1px 0 #c01303, 0 2px 1px #c01303;
            }
        }

        .product {
            position: relative;
            height: 138px;
            flex-grow: 1;
            border-radius: 7px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
            padding: 1px;
            background: ${(props: any) =>
                props.backgroundSrc
                    ? `url("${props.backgroundSrc}")`
                    : createGradientOrSolid(props.backgroundColor)};
            background-clip: content-box;
            background-size: cover;
            background-position: center;

            .badge-wrapper {
                position: absolute;
            }

            .amount {
                position: relative;
                z-index: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                color: ${(props: any) => props.productColor};
                text-shadow: -1px -1px 0 #7e3100, 1px -1px 0 #7e3100,
                    -1px 1px 0 #7e3100, 1px 1px 0 #7e3100, 0 2px 1px #7e3100;
                text-align: left;
                font-size: 1.75rem;
                line-height: normal;
                margin-top: 5px;

                .stroked {
                    font-size: 1rem;
                    font-style: normal;
                    font-weight: 400;
                    color: #fff;
                    line-height: normal;
                    position: relative;

                    &::after {
                        content: ' ';
                        height: 1px;
                        width: 130%;
                        background: #d8232a;
                        position: absolute;
                        left: -15%;
                        top: 50%;
                    }
                }

                img {
                    height: 14px;
                    aspect-ratio: 1/1;
                    margin: 0 4px 0 0;
                }
            }

            .image-container {
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                position: absolute;

                .image {
                    height: 100%;
                    width: 100%;
                    object-fit: cover;
                    border-radius: 7px;
                }
            }
        }
    }

    .price-container {
        width: 100%;
        position: absolute;
        bottom: 0;

        .price {
            position: relative;
            border: 1px solid #074e0e;
            height: auto;
            width: auto;
            padding: 3px 4px 4px 4px;
            border-radius: 0 0 7px 7px;

            &:before {
                content: '';
                width: 6px;
                height: 4px;
                background-color: white;
                border-radius: 50%;
                transform: rotate(-60deg);
                position: absolute;
                top: 5px;
                left: 7px;
            }

            &:after {
                content: '';
                position: absolute;
                bottom: 0;
                height: 16px;
                width: 100%;
                border-radius: 0 0 6px 6px;
                background: linear-gradient(270deg, #008668 0%, #6b9a11 100%);
            }

            .totalPrice {
                position: relative;
                z-index: 1;
                font-size: 1.25rem;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                text-shadow: -1px -1px 0 #034713, 1px -1px 0 #034713,
                    -1px 1px 0 #034713, 1px 1px 0 #034713, 0 2px 1px #034713;
                align-items: center;
            }
        }
    }

    @media (min-width: 375px) {
        .container {
            .ribbon {
                bottom: 36px;
            }
        }
    }
` as any;
